import React from 'react'

export default function Paragraph(props) {
    const rootClassName = "mt-4 text-base " + props.className
    return (
        <p className={rootClassName}>{props.children}</p>
    )
}
